import { MTableEditField } from '@material-table/core';
import CustomLookUpField from "components/Tables/CustomLookUpField/CustomLookUpField";
import React from 'react';
import { SUBSTANCE } from 'utils/constants/coreConstants';
import { DISTRIBUIDOR, FABRICANTE, IMPORTADOR, UJ } from 'utils/constants/reach_role';
import { shortDate as dateFormater } from 'utils/helperFunctions/dateFormat';


export default (rawMaterialType, suppliers) => {
    const columns = [
        {
            title: 'Código',
            field: 'code',
            minWidth: 100,
            initialEditValue: '',
            headerStyle: {
                textAlign: 'center'
            },
            cellStyle: {
                textAlign: 'left'
            }
        },
        {
            title: 'Designação Comercial',
            field: 'trade_name',
            initialEditValue: '',
            minWidth: 200,
            headerStyle: {
                textAlign: 'center'
            },
            cellStyle: {
                textAlign: 'left'
            },
            editComponent: (props) => <MTableEditField fullWidth {...props} multiline/>
        },
        {
            title: 'Fornecedor',
            field: 'supplier_id',
            lookup: suppliers,
            initialEditValue: Object.keys(suppliers)[0],
            editable: 'onAdd',
            minWidth: 200,
            headerStyle: {
                textAlign: 'center'
            },
            cellStyle: {
                textAlign: 'left'
            },
            editComponent: (props) => <CustomLookUpField fullWidth {...props}/>
        },
        {
            title: 'Papel Reach',
            field: 'reach_role',
            sorting: false,
            minWidth: 50,
            editable: 'onAdd',
            headerStyle: {
                textAlign: 'center'
            },
            cellStyle: {
                textAlign: 'center'
            },
            initialEditValue: UJ,
            lookup: {
                //'-': '-',
                [UJ]: 'UJ',
                [FABRICANTE]: 'Fabricante',
                [IMPORTADOR]: 'Importador',
                [DISTRIBUIDOR]: 'Distribuidor'
            }
        },
        {
            title: 'Data FDS',
            field: 'sds_date',
            type: 'date',
            minWidth: 100,
            headerStyle: {
                textAlign: 'center'
            },
            cellStyle: {
                textAlign: 'center'
            },
            initialEditValue: null,
            render: ({ sds_date }) => sds_date ? dateFormater(sds_date) : null,
            editComponent: (props) => <MTableEditField fullWidth {...props}/>
        },
        {
            title: 'Revisão FDS',
            field: 'sds_revision',
            sorting: false,
            minWidth: 50,
            headerStyle: {
                textAlign: 'center'
            },
            cellStyle: {
                textAlign: 'center'
            }
        },
        {
            title: 'CE',
            field: 'exposure_scenario',
            sorting: false,
            minWidth: 50,
            headerStyle: {
                textAlign: 'center'
            },
            cellStyle: {
                textAlign: 'center'
            },
            initialEditValue: 'sim',
            lookup: {
                //'-': '-',
                'sim': 'Sim',
                'nao': 'Não',
                'na': 'N/A'
            }
        },
        {
            title: 'Data Recepção CE',
            field: 'received_on',
            initialEditValue: null,
            type: 'date',
            sorting: false,
            minWidth: 100,
            headerStyle: {
                textAlign: 'center'
            },
            cellStyle: {
                textAlign: 'center'
            },
            render: ({ received_on }) => received_on ? dateFormater(received_on) : null
        }
    ];

    if (rawMaterialType === SUBSTANCE) {
        columns.push({
            title: 'Nº Registo',
            field: 'registration_number',
            initialEditValue: '',
            sorting: false,
            minWidth: 250,
            headerStyle: {
                textAlign: 'center'
            },
            cellStyle: {
                textAlign: 'center'
            }
        });
    }

    columns.push({
        title: 'Observações',
        field: 'observations',
        initialEditValue: '',
        sorting: false,
        minWidth: 200,
        headerStyle: {
            textAlign: 'center'
        },
        cellStyle: {
            textAlign: 'left'
        },
        editComponent: (props) => <MTableEditField fullWidth {...props} multiline/>
    });

    return columns;
};
